export default "__VITE_ASSET__DyYgli3P__"